import CircleIcon from 'components/CircleIcon';
import PassengersTableLargeScreen from 'components/quoteBooking/PassengersTableLargeScreen';
import PassengersTableSmallScreen from 'components/quoteBooking/PassengersTableSmallScreen';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ReactComponent as PassengerIcon } from '../../images/icons/passenger.svg';

export default function Passengers({ data }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <PassengerIcon style={{ fill: primaryColour || '#FFF' }} />
        </CircleIcon>
        <SectionTitle label="Passengers" className="ml-[10px] mt-1" />
      </div>
      <div className="mt-[40px]">
        <PassengersTableSmallScreen
          className="lg:hidden"
          passengerList={data?.passengers}
        />
        <PassengersTableLargeScreen
          className="hidden lg:table"
          passengerList={data?.passengers}
        />
      </div>
    </>
  );
}
